import React, { Component } from 'react';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

export class AdesaoPonto extends Component {


    render() {
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col">{`${this.props.adesaoPonto.empresa.id} - ${this.props.adesaoPonto.empresa.nome}`}</div>
                        <div className="col">{this.props.adesaoPonto.peso}</div>
                        <div className="col">{this.props.adesaoPonto.quantidadePonto}</div>
                        <div className="col">{this.props.adesaoPonto.habilitadoGeracaoPontos ? 'Sim' : 'Não'}</div>
                        <div className="col">{this.props.adesaoPonto.habilitadoConsumoPontos ? 'Sim' : 'Não'}</div>
                        <div className="col" style={{textAlign: 'center'}}>
                            <div className="acoes">
                                <div className="botoes">                                    
                                    <button type="button" className="btn btn-editar"
                                        data-toggle="modal"
                                        data-target="#"
                                        onClick={() =>  {
                                            this.props.history.push('/painel-cadastro-configuracao-ponto')
                                            this.props.selecionarAdesaoPonto(this.props.adesaoPonto)
                                        }}>
                                        <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(null,
    {
        selecionarAdesaoPonto
    })(reduxForm({
        form: 'formularioPainelAdesaoPontos'
})(AdesaoPonto)))